import React, { useState, useEffect } from "react";
import { Input, message } from "antd";
import Button from "react-bootstrap/Button";
import { useNavigate, useParams } from "react-router-dom"; // Import useParams to get the id from URL
import axios from "axios";
import { API_URL } from "../Api/Config"; // Import the API URL
import { IoCaretBackOutline } from "react-icons/io5";

const EditDelivery = () => {
  const { id } = useParams<{ id: string }>(); // Get the id from the URL params
  const [formData, setFormData] = useState({
    state: "",
    district: "",
    pincode: "",
    standardDeliveryDate: "",
    expressDeliveryDate: "",
  });
  const navigate = useNavigate(); // Initialize useNavigate hook
  const fetchDeliveryData = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/delivery-info/${id}`,{
        headers:{
           Authorization:`Bearer ${localStorage.getItem("dashtoken")}`
        }
      });
      setFormData(response.data); // Set the fetched data into the form state
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchDeliveryData();
  }, [id]);

  const handleInputChange = (e: { target: { name: any; value: any } }) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    try {
      const response = await axios.patch(
        `${API_URL}/api/delivery-info/${id}`,
        formData,{
          headers:{
             Authorization:`Bearer ${localStorage.getItem("dashtoken")}`
          }
        }
      );
      message.success("Delivery updated successfully");
      navigate("/settings/set-estimate-delivery");
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };

  return (
    <section className="section-main top-gap" style={{ marginLeft: "18%" }}>
      <div className="head-txt d-flex pb-3">
        <a
          onClick={() => window.history.back()}
          className="icons-div"
          style={{
            textDecoration: "none",
            cursor: "pointer",
            color: "#000",
          }}
        >
          <IoCaretBackOutline className="mb-1" />
          <span>Edit Estimate Delivery</span>
        </a>
      </div>

      <form onSubmit={handleSubmit}>
        <div>
          <label className="addbrand-label">State  <span style={{color:"red"}}>*</span></label>
          <br />
          <Input
            className="brand-input"
            style={{ width: "445px" }}
            name="state"
            value={formData.state}
            onChange={handleInputChange}
          />
        </div>
        <div>
          <label className="addbrand-label">District  <span style={{color:"red"}}>*</span></label>
          <br />
          <Input
            style={{ width: "445px" }}
            className="brand-input"
            name="district"
            value={formData.district}
            onChange={handleInputChange}
          />
        </div>
        <div>
          <label className="addbrand-label">Pincode <span style={{color:"red"}}>*</span></label>
          <br />
          <Input
            style={{ width: "445px" }}
            className="brand-input"
            name="pincode"
            value={formData.pincode}
            onChange={handleInputChange}
          />
        </div>
        <div>
          <label className="addbrand-label">Standard Delivery</label>
          <br />
          <Input
            style={{ width: "445px" }}
            className="brand-input"
            name="standardDeliveryDate"
            value={formData.standardDeliveryDate}
            onChange={handleInputChange}
          />
        </div>
        <div>
          <label className="addbrand-label">Express Delivery  <span style={{color:"red"}}>*</span></label>
          <br />
          <Input
            style={{ width: "445px" }}
            className="brand-input"
            name="expressDeliveryDate"
            value={formData.expressDeliveryDate}
            onChange={handleInputChange}
          />
        </div>

        <div className="mt-4">
          <Button type="submit" className="btn-1">
            Save Changes
          </Button>
        </div>
      </form>
    </section>
  );
};

export default EditDelivery;
